import { object } from "yup";

import { addressValidationSchema } from "@dzambalaorg/yup-rules-eth";

export const validationSchema = object().shape({
  account: addressValidationSchema,
});
